import { ReservationStatus } from "@common/enum/ReservationStatus";
import { FieldType, Model, Schema } from "@core/index";
import { IAirTransaction } from "./AirTransaction";

export interface IPnrInfoRequest extends IAirTransaction {
    pnr?: string;
    ticketNumber?: string;
    contactLastName?: string;
    departureDate?: number;
    status?: ReservationStatus;
}

export class PnrInfoRequest extends Model implements IPnrInfoRequest {
    public static schema: Schema = new Schema("PnrInfoRequest");
    public pnr?: string;
    public ticketNumber?: string;
    public contactLastName?: string;
    public departureDate?: number;
    public status?: ReservationStatus;
    public jsessionId?: string;

    constructor(values: IPnrInfoRequest) {
        super(PnrInfoRequest.schema);
        this.setValues(values);
    }
}

PnrInfoRequest.schema.addField("pnr").type(FieldType.String).required().pattern(/^[0-9]{8}$/);
PnrInfoRequest.schema.addField("ticketNumber").type(FieldType.String);
PnrInfoRequest.schema.addField("contactLastName").type(FieldType.String).required().pattern(/^[a-zA-Z ]*$/);
PnrInfoRequest.schema.addField("departureDate").type(FieldType.Timestamp).required();
